document.addEventListener('DOMContentLoaded', function() {
  function updateProductButtonsState(isAvailable, variantId) {
    const productForm = document.querySelector('.product-form');
    if (!productForm) return;

    const addToCartButton = productForm.querySelector('.add-to-cart-product');
    if (!addToCartButton) return;

    const btnText = addToCartButton.querySelector('.btn__text');
    if (!btnText) return;

    if (isAvailable) {
      addToCartButton.classList.remove('notify-me');
      btnText.textContent = window.theme?.strings?.addToCart || 'Add to Cart';
      addToCartButton.removeAttribute('id');
      addToCartButton.removeAttribute('data-variant-id');
      addToCartButton.setAttribute('data-add-to-cart', '');
    } else {
      addToCartButton.classList.add('notify-me');
      btnText.textContent = window.theme?.strings?.notifyMe || 'Notify Me';
      addToCartButton.setAttribute('data-variant-id', variantId);
      addToCartButton.setAttribute('id', 'BIS_trigger');
      addToCartButton.removeAttribute('data-add-to-cart');
    }
  }

  const productVariantOptions = document.querySelectorAll('.product__form__outer .radio__button input');
  productVariantOptions.forEach(function(option) {
    option.addEventListener('change', function() {
      const variantId = this.getAttribute('data-product-variant');
      const isAvailable = !this.closest('.radio__button').querySelector('.sold-out');
      
      const url = new window.URL(window.location);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({path: url.toString()}, '', url.toString());

      updateProductButtonsState(isAvailable, variantId);

      const event = new CustomEvent('variant:change', {
        detail: {
          variant: {
            id: variantId,
            available: isAvailable
          }
        }
      });
      document.dispatchEvent(event);
    });
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const button = mutation.target;
        if (button.classList.contains('add-to-cart-product')) {
          const isNotifyMe = button.classList.contains('notify-me');
          const btnText = button.querySelector('.btn__text');
          if (btnText) {
            btnText.textContent = isNotifyMe ? 
              (window.theme?.strings?.notifyMe || 'Notify Me') : 
              (window.theme?.strings?.addToCart || 'Add to Cart');
          }
        }
      }
    });
  });

  const productForm = document.querySelector('.product-form');
  if (productForm) {
    observer.observe(productForm, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  const initialVariant = document.querySelector('.product__form__outer .radio__button input:checked');
  if (initialVariant) {
    const isAvailable = !initialVariant.closest('.radio__button').querySelector('.sold-out');
    const variantId = initialVariant.getAttribute('data-product-variant');
    updateProductButtonsState(isAvailable, variantId);
  }

  document.addEventListener('variant:change', function(event) {
    if (event.detail && event.detail.variant) {
      const { available, id } = event.detail.variant;
      updateProductButtonsState(available, id);
    }
  });
}); 